import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CancellationsAndRefundsPage from "./pages/CancellationsAndRefundsPage";
// import ResetPasswordPage from "./pages/ResetPasswordPage";
// import UnravelledHomepage from "./unravelled/Homepage";

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route
          path="/cancellations-and-refunds"
          element={<CancellationsAndRefundsPage />}
        />
      </Route>
    </Routes>
  );
}

export default App;
